/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */


!function(e){var n=!1;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var o=window.Cookies,t=window.Cookies=e();t.noConflict=function(){return window.Cookies=o,t}}}(function(){function e(){for(var e=0,n={};e<arguments.length;e++){var o=arguments[e];for(var t in o)n[t]=o[t]}return n}function n(o){function t(n,r,i){var c;if("undefined"!=typeof document){if(arguments.length>1){if("number"==typeof(i=e({path:"/"},t.defaults,i)).expires){var a=new Date;a.setMilliseconds(a.getMilliseconds()+864e5*i.expires),i.expires=a}i.expires=i.expires?i.expires.toUTCString():"";try{/^[\{\[]/.test(c=JSON.stringify(r))&&(r=c)}catch(e){}r=o.write?o.write(r,n):encodeURIComponent(String(r)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),n=(n=(n=encodeURIComponent(String(n))).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent)).replace(/[\(\)]/g,escape);var s="";for(var f in i)i[f]&&(s+="; "+f,!0!==i[f]&&(s+="="+i[f]));return document.cookie=n+"="+r+s}n||(c={});for(var p=document.cookie?document.cookie.split("; "):[],d=/(%[0-9A-Z]{2})+/g,u=0;u<p.length;u++){var l=p[u].split("="),C=l.slice(1).join("=");this.json||'"'!==C.charAt(0)||(C=C.slice(1,-1));try{var g=l[0].replace(d,decodeURIComponent);if(C=o.read?o.read(C,g):o(C,g)||C.replace(d,decodeURIComponent),this.json)try{C=JSON.parse(C)}catch(e){}if(n===g){c=C;break}n||(c[g]=C)}catch(e){}}return c}}return t.set=t,t.get=function(e){return t.call(t,e)},t.getJSON=function(){return t.apply({json:!0},[].slice.call(arguments))},t.defaults={},t.remove=function(n,o){t(n,"",e(o,{expires:-1}))},t.withConverter=n,t}return n(function(){})});

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages


        // add custom media query sizes for Foundation Interchange
        Foundation.Interchange.SPECIAL_QUERIES.smallretina = 'only screen and (min-width: 1px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 1px) and (min--moz-device-pixel-ratio: 2), only screen and (min-width: 1px) and (-o-min-device-pixel-ratio: 2/1), only screen and (min-width: 1px) and (min-device-pixel-ratio: 2), only screen and (min-width: 1px) and (min-resolution: 192dpi), only screen and (min-width: 1px) and (min-resolution: 2dppx)';
        Foundation.Interchange.SPECIAL_QUERIES.mediumretina = 'only screen and (min-width: 641px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 641px) and (min--moz-device-pixel-ratio: 2), only screen and (min-width: 641px) and (-o-min-device-pixel-ratio: 2/1), only screen and (min-width: 641px) and (min-device-pixel-ratio: 2), only screen and (min-width: 641px) and (min-resolution: 192dpi), only screen and (min-width: 641px) and (min-resolution: 2dppx)';
        Foundation.Interchange.SPECIAL_QUERIES.largeretina = 'only screen and (min-width: 1025px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 1025px) and (min--moz-device-pixel-ratio: 2), only screen and (min-width: 1025px) and (-o-min-device-pixel-ratio: 2/1), only screen and (min-width: 1025px) and (min-device-pixel-ratio: 2), only screen and (min-width: 1025px) and (min-resolution: 192dpi), only screen and (min-width: 1025px) and (min-resolution: 2dppx)';
        Foundation.Interchange.SPECIAL_QUERIES.xlargeretina = 'only screen and (min-width: 1921px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 1921px) and (min--moz-device-pixel-ratio: 2), only screen and (min-width: 1921px) and (-o-min-device-pixel-ratio: 2/1), only screen and (min-width: 1921px) and (min-device-pixel-ratio: 2), only screen and (min-width: 1921px) and (min-resolution: 192dpi), only screen and (min-width: 1921px) and (min-resolution: 2dppx)';

        // init Foundation JavaScript
        $(document).foundation(); 

        // add plz pattern for Foundation Abide
        Foundation.Abide.defaults.patterns.plz = /^([0]{1}[1-9]{1}|[1-9]{1}[0-9]{1})[0-9]{3}$/;

        // set default Sticky size for Foundation Sticky
        Foundation.Sticky.defaults.stickyOn = 'large';

        // Mobile Menu
        Foundation.DropdownMenu.defaults.closeOnClick = true;

        // change body class on scroll
        $(window).scroll(function() {
          if ($(this).scrollTop() > 50) {
            $('body').addClass('solid-header');
          } else {
            $('body').removeClass('solid-header');
          }
        });

        // add no-touch class for desktop browsers
        var touchsupport = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
        if (!touchsupport) { 
            document.documentElement.className += " no-touch ";
        }



        $('.slider-gif').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          autoplay: true,
          fade: true,
          speed: 0,
          pauseOnHover: false,
          autoplaySpeed: 500
        });




          $('.slider-normal').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            autoplay: false
          });

        $('.slider-controls').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          fade: true,
          autoplay: false
        });


        $('.slider-autoplay').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          autoplay: true,
          pauseOnHover: false,
          fade: true,
          autoplaySpeed: 1000
        });

        $('.slider-autoplay-controls').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          arrows: true,
          autoplay: true,
          pauseOnHover: false,
          fade: true,
          autoplaySpeed: 1000
        });



        // Toggle menu
        $('[data-off-canvas]').on("opened.zf.offcanvas", function(e) {
          $('#toggle-menu').addClass('open');
          $('#main-header').addClass('toggle-menu-open');
          $('body').addClass('no-scroll toggle-menu-open');
          $('#toggle-menu-button').addClass('active');
        });
        $('[data-off-canvas]').on("closed.zf.offcanvas", function(e) {
          $('#toggle-menu').removeClass('open');
          $('#main-header').removeClass('toggle-menu-open');
          $('body').removeClass('no-scroll toggle-menu-open');
          $('#toggle-menu-button').removeClass('active');          
        });

        $('#toggle-menu .menu-item-has-children > a').click(function(){
           var i = 0;
           var parent = $(this).parent();
           $('#toggle-menu ul > li').each(function(){
             if($('#toggle-menu ul > li').index(parent)!==i){
               $(this).removeClass('open');
               $(this).find('*').removeClass('open');
             }
             i++;
           });
           $(this).parent().toggleClass('open');
           $(this).toggleClass('open');
           $(this).siblings('.foldable-content').toggleClass('open');
           return false;
        });     

        // Smooth scrolling
        if(window.location.hash) {
          console.log('');
          $('html, body').animate({
              scrollTop: $(window.location.hash).offset().top - 5
          }, 1);
        }



        // Scrolldown Button scrolling
        $('.scrolldown-button').click(function(){
          var nextSection = $(this).closest('section').next();

          $('html, body').animate({
              scrollTop: nextSection.offset().top
          }, 1000);
        });


        // cookie disclainer
        var cookieBox = document.getElementById('js-cookie-box');
        var cookieButton = document.getElementById('js-cookie-button');

        if (!Cookies.get('cookie-box')) {

          cookieBox.classList.remove('cookie-box--hide');

          $(".close-cookie-button").on("click", function(){
            Cookies.set('cookie-box', true, { expires: 7 });
            cookieBox.classList.add('cookie-box--hide');
          });
        }




        if( /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent) ) {
          $(".video-left, .video-right, .popup-close-area-left, .popup-close-area-right").hide();
          $(".mobile-banner").addClass("mobile-visible");
        }
        else {
          $(".video-left, .video-right").show();
          $(".mobile-banner").removeClass("mobile-visible");
        }


        // Popups
          $(".open-left-popup").on("click", function(){
              $(".popup-left, .popup-left-content, .popup-close-area-left").addClass("active");
            $(".main-header").hide();
            $("body, html").addClass("noscroll");
          });

          $(".open-right-popup").on("click", function(){
            $(".main-header").hide();
              $(".popup-right, .popup-right-content, .popup-close-area-right").addClass("active");
            $("body, html").addClass("noscroll");
          });

          $(".close, .popup-close-area-left, .popup-close-area-right").on("click", function(){
            $(".main-header").show();
              $(".popup-left, .popup-left-content, .popup-right, .popup-right-content, .popup-background, .popup-close-area-left, .popup-close-area-right ").removeClass("active");
            $("body, html").removeClass("noscroll");
          });




// Arrow Down Scroll
        $(document).on('click', '.arrow-down', function(event){
          event.preventDefault();
          var viewportHeight = $(window).height();

          $('html, body').animate({
            scrollTop: viewportHeight + 10,
            complete: function () {
              //Hide your button here
            }
          }, 700);
        });



        // fire initial resize
        $(window).trigger('resize');
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired  
       
      },
      resize: function() {

        if( /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent) ) {
          $(".video-left, .video-right").hide();
          $(".mobile-banner").addClass("mobile-visible");
        }
        else {
          $(".video-left, .video-right").show();
          $(".mobile-banner").removeClass("mobile-visible");
        }

        var headerHeight = $('#main-header').outerHeight(true);
        var footerHeight = $("#footer-wrap").outerHeight(true);
        var windowHeight = $(window).height();
        var combinedHeight = windowHeight - headerHeight - footerHeight;

        // Sliders
        var resizeSliders = null;

        clearTimeout(resizeSliders);
        resizeSliders = setTimeout(
          function() {
            function renderCounter(slick,carouselId) {
              var slidesToShow;
              if(slick.activeBreakpoint!==null){
                slidesToShow = slick.breakpointSettings[slick.activeBreakpoint].slidesToShow;
              } else {
                slidesToShow = slick.options.slidesToShow;
              }
    
              if($('#'+carouselId).parents('.slider-wrapper').find('.slick-next').length>0){
                $('#'+carouselId).parents('.slider-wrapper').find('.counter').html( (slick.currentSlide+slidesToShow)/slidesToShow +' / ' + Math.ceil((slick.slideCount)/slidesToShow));
                $('#'+carouselId).parents('.slider-wrapper').find('.slider-control').show();
              } else {
                $('#'+carouselId).parents('.slider-wrapper').find('.counter').html('');
                $('#'+carouselId).parents('.slider-wrapper').find('.slider-control').hide();
              }
            } 
    
            $('.common-slider').each(function (idx, item) {
              if ($(this).hasClass('slick-initialized')) {
                  $(this).slick('resize');
              } else {
                var carouselId = "carousel_" + idx;
                this.id = carouselId;
                $(this).attr('data-counter','carousel_slick-control_' + idx);
                $(this).next('.slider-control').attr('id','carousel_slick-control_' + idx);
                
                $(this).on('init', function(event, slick) {
                  //console.log('init');
                });
    
                $(this).on('setPosition', function(event, slick) {
                  //console.log('setPosition');
                  renderCounter(slick,carouselId);
                });
    
                $(this).on('afterChange', function(event, slick, currentSlide){
                  //console.log('afterChange');
                });  

                $(this).on('edge', function(event, slick, direction){
                  //console.log('edge was hit');
                });                          
    
                $(this).slick();

              }
            }); 

          },
          400
        );

        $(".section-headline:contains(' // ')").html(function(_, html) {
          return  html.replace(/\/{2,}/g, ' <span class="icon-typosign"></span> ');
        });

        // replace double slashes with icon
        function replace_slashes() {

          $(".section-headline:contains(' // ')").html(function(_, html) {
            return  html.replace(/\/{2,}/g, ' <span class="icon-typosign"></span> ');
          });
          $("section .post-item-hover-text:contains(' // ')").html(function(_, html) {
            return  html.replace(/\/{2,}/g, ' <span class="icon-typosign"></span> ');
          });          
          $("section .post-item-hover-name:contains(' // ')").html(function(_, html) {
            return  html.replace(/\/{2,}/g, ' <span class="icon-typosign"></span> ');
          });
        }             

        // Load ajax posts
        function load_ajax_posts () {
            var settingsKey = $(this).attr('data-posts-selector-index');
            var currentPostID = $(this).attr('data-posts-selector-current-post-id');
        
            var currentManualTeaserArray = $(this).attr('data-posts-selector-manual-teaser-array');
            var currentCategory = $(this).attr('data-posts-selector-category');
            var currentTag = $(this).attr('data-posts-selector-tag');
            var currentHowManyTeasers = $(this).attr('data-posts-selector-how-many-teasers');
            var currentNumRowsMobile = $(this).attr('data-posts-selector-num-rows-mobile');
            var currentNumRowsDesktop = $(this).attr('data-posts-selector-num-rows-desktop');
      
            var currentPostCount = $(this).find('.load-more').attr('data-load-more-current-post-count');
            var currentOffset = $(this).find('.load-more').attr('data-load-more-current-offset');
            
            var currentPostsPerPage = -1; 
            var currentMediaquery = '';
            
            if (currentHowManyTeasers !== 'all') {
              if (Foundation.MediaQuery.is('small only')) {
                  currentPostsPerPage = currentNumRowsMobile;
              }
              if (Foundation.MediaQuery.is('medium only')) {
                  currentPostsPerPage = currentNumRowsDesktop * 3;
              }
              if (Foundation.MediaQuery.is('large only')) {
                  currentPostsPerPage = currentNumRowsDesktop * 3;
              }
              if (Foundation.MediaQuery.atLeast('xlarge')) {
                  currentPostsPerPage = currentNumRowsDesktop * 3;
              }
            }
      
            if (Foundation.MediaQuery.is('small only')) {
                currentMediaquery = 'small';
            }
            if (Foundation.MediaQuery.is('medium only')) {
                currentMediaquery = 'medium';
            }
            if (Foundation.MediaQuery.is('large only')) {
                currentMediaquery = 'large';
            }
            if (Foundation.MediaQuery.atLeast('xlarge')) {
                currentMediaquery = 'xlarge';
            }      
            
            if (!($('.posts-selector-multiple-' + settingsKey).hasClass('loader-loading'))) {
            
              $.ajax({
                type: "GET",
                url: SiteParameters.ajax_url,
                dataType: 'html',
                data: ({
                  action: 'load_responsive_posts',
                  currentsettingskey: settingsKey,
                  currentpostid: currentPostID,
                  currentpostsperpage: currentPostsPerPage,
                  currentmediaquery: currentMediaquery,
                  currentmanualteaserarray: currentManualTeaserArray,
                  currentcategory: currentCategory,
                  currenttag: currentTag,
                  currentpostcount: currentPostCount,
                  currentoffset: currentOffset
                }),
                beforeSend : function () {
                  $('.posts-selector-multiple-' + settingsKey).addClass('loader-loading');
                },              
                success: function(data) {
                  if(data) {
                    if ( $('#load-more-' + settingsKey).length > 0 ) {
                      $('#load-more-' + settingsKey).replaceWith(data);
                    } else {
                      $('.posts-selector-multiple-' + settingsKey).prepend(data);
                    }

  
                  } else {
                    console.log("no data");
                  }
                },
                error: function(data) {
                  console.log("Error :( " + data);
                  return false;
                },
                complete:   function() {

                  replace_slashes();
                  $('.posts-selector-multiple-' + settingsKey).removeClass('loader-loading');          
                  // Trigger event after the posts are loaded
                  var loadResponsivePostsCompleteEvent = new Event('loadResponsivePostsComplete');
                  document.dispatchEvent(loadResponsivePostsCompleteEvent);              
                }           
              });
            }


            return false; 
        }            

        var resizeMorePosts = null;
        clearTimeout(resizeMorePosts);
        resizeMorePosts = setTimeout(
          function() {
            $('.more-posts-section .post-item-wrap').each(function(){
              $(this).remove(); 
            });  
            $('.more-posts-section .load-more').each(function(){
              $(this).remove(); 
            });           
            $.each($('.posts-selector-multiple'), load_ajax_posts); 
          },
          400
        ); 
              
        $(".posts-selector-multiple").on('click', 'button.load-more', function() {
          var currentParent = $(this).closest('.posts-selector-multiple');
          $.each(currentParent, load_ajax_posts);
        });        

        document.addEventListener('loadResponsivePostsComplete', function(e) {
          //console.log("loadResponsivePostsComplete");        
        }, false); 

        // Sticky footer
        function stickyFooter() {
          if (Foundation.MediaQuery.atLeast('large')) {
            $("main.main").css('min-height', combinedHeight + "px");
          } else {
            $("main.main").css('min-height', "100vh");          
          }                    
        }

        if ($( "#footer-wrap" ).length) {
          stickyFooter();
        }       

      },
      windowload: function() {
        //console.log('loaded');
        $('html').addClass('window-loaded');
      }
    },
    // Home page
    'home': {
      init: function() {

        jQuery(function($) {

          var $nav = $('#main-header');
          var $win = $(window);
          var winH = $win.height();

          $win.on("scroll", function () {
            if ($(this).scrollTop() > winH ) {
              $nav.addClass("teaser-header");
            } else {
              $nav.removeClass("teaser-header");
            }
          }).on("resize", function(){
            winH = $(this).height();
          });

        });
        // JavaScript to be fired on the home page

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS

      },
      resize: function() {

      },
      windowload: function() {

      }
    },
    'page_template_template_layouts': {
      init: function() {

      },
      finalize: function() {

      },
      resize: function() {

      },
      windowload: function() {

      }
    }    
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }


    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
        //UTIL.fire(classnm, 'resize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
      //UTIL.fire('common','resize');
    },
    resizeEvents: function() {

      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'resize');
      });

      UTIL.fire('common','resize');


    },
    windowLoadEvents: function() {

      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm, 'windowload');
      });

      UTIL.fire('common','windowload');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
  $(window).on("load",UTIL.windowLoadEvents);

  // Resize Events
  var trackWindowWidth = $(window).width();

  $(window).resize(function (trackResizeEvent) {
      //console.log(!trackResizeEvent.isTrigger ? ' resize' : ' triggerd');
  
      // Check window width has actually changed and it's not just iOS triggering a resize event on scroll || the resize event was caused by $(window).trigger('resize');
      if (($(window).width() !== trackWindowWidth) || trackResizeEvent.isTrigger) {
          // Update the window width for next time
          trackWindowWidth = $(window).width();

          UTIL.resizeEvents();
      }  
  });


})(jQuery); // Fully reference jQuery after this point.

